<template>
  <div class="d-flex flex-md-row justify-content-md-between align-items-start flex-column">
    <div class="icon-inputs flex-fill mr-md-2 w-100">
      <div class="form-group">
        <h6>{{ $t('lang.transfer.origin') }}</h6>
        <button
          id="origin_btn"
          type="button"
          class="btn btn-light dropdown-toggle select-button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
        >
          <span v-if="origin">
            <i :class="zoneIcon(origin.type)" />  {{ origin.label }}
          </span>
          <span v-else>
            {{ $t('lang.transfer.select_origin') }}
          </span>
        </button>
        <div
          id="origin_dropdown"
          class="dropdown-menu prices-dropdown"
        >
          <button
            v-for="from in zones"
            :key="from.label"
            class="dropdown-item"
            type="button"
            @click="updateDestination(from)"
          >
            <i :class="zoneIcon(from.type)" /> {{ from.label }}
            <span v-if="from.iata">({{ from.iata }})</span>
          </button>
        </div>
      </div>
    </div>

    <div class="text-center ml-md-2 mr-md-2 align-self-end ">
      <div class="form-group mb-0 mb-lg-3">
        <button
          class="d-none d-md-inline btn btn-reverse"
          @click="reverse()"
        >
          <i class="fa-solid fa-arrow-right-arrow-left" />
        </button>
        <button
          class="d-inline d-md-none btn btn-reverse btn-reverse-mobile"
          @click="reverse()"
        >
          <i class="fa-solid fa-arrow-right-arrow-left" />
        </button>
      </div>
    </div>

    <div class="icon-inputs flex-fill ml-md-2 mr-md-2 w-100">
      <div class="form-group">
        <h6>{{ $t('lang.transfer.destination') }}</h6>
        <button
          id="destination_btn"
          type="button"
          class="btn btn-light dropdown-toggle select-button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
        >
          <span v-if="destination">
            <i :class="zoneIcon(destination.type)" />  {{ destination.label }}
          </span>
          <span v-else>
            <span v-if="!origin">
              {{ $t('lang.transfer.select_origin') }}
            </span>
            <span v-else>
              {{ $t('lang.transfer.select_destination') }}
            </span>
          </span>
        </button>
        <div class="dropdown-menu prices-dropdown">
          <button
            v-for="to in destinationsList"
            :key="to.label"
            class="dropdown-item"
            type="button"
            @click="zonesSelected(to)"
          >
            <i :class="zoneIcon(to.type)" /> {{ to.label }}
            <span v-if="to.iata">({{ to.iata }})</span>
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="isRideType"
      class=" icon-inputs flex-fill ml-md-2 w-100"
    >
      <div class="form-group">
        <h6>{{ $t('lang.transfer.date') }}</h6>
        <button
          id="time_btn"
          type="button"
          class="btn btn-light dropdown-toggle select-button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
        >
          <span>
            <i class="icon-clock" />  {{ dateToShow }}
          </span>
        </button>
        <div class="dropdown-menu prices-dropdown overflow-hidden">
          <button
            class="dropdown-item"
            type="button"
            @click="clickNow()"
          >
            <i class="icon-clock" /> {{ $t('lang.transfer.now') }}
          </button>
          <button
            class="dropdown-item"
            type="button"

            @click="openDatetimeSelector()"
          >
            <i class="icon-calendar" />  {{ $t('lang.transfer.schedule') }}
          </button>
        </div>
      </div>
    </div>

    <Datetime
      v-model="selectedDate"
      input-id="datetime"
      type="datetime"
      style="height: 0"
      input-style="border: none; font-size: 0"
      :value="now"
      :hour-step="1"
      :minute-step="10"
      :min-datetime="now"
      :week-start="7"
      :format="{
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
      }"
      :phrases="{
        ok: $t('lang.search.calendar_continue'),
        cancel: $t('lang.search.calendar_cancel'),
      }"
      auto
      @close="closeDatePicker"
    />
  </div>
</template>

<script>
import { Datetime } from 'vue-datetime';

import { formatDateToDisplay } from '@/utils/dateFormatters';

export default {
  name: 'OriginAndDestination',
  components: {
    Datetime,
  },
  props: {
    zones: {
      type: Array,
      required: true,
    },
    defaultZones: {
      type: Object,
      required: false,
    },
    isRideType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      origin: null,
      destination: null,

      originsList: this.zones,
      destinationsList: [],

      now: new Date(
        ((new Date()).setMinutes((new Date()).getMinutes())),
      ).toISOString(), // Now in the correct timezone

      dateToShow: this.$t('lang.transfer.now'),
      selectedDate: null,
    };
  },

  watch: {
    defaultZones() {
      this.updateDefaultZones();
    },
  },

  mounted() {
    if (this.defaultZones) {
      this.updateDefaultZones();
    } else {
      document.getElementById('origin_btn').click();
    }
  },

  methods: {
    zoneIcon(type) {
      switch (type) {
        case 'Airport':
          return 'icon-plane';
        case 'Zone':
          return 'icon-commerical-building';
        case 'Port':
          return 'icon-ferry';
        case 'Train':
          return 'icon-aboveground-rail';
        case 'Terminal':
          return 'icon-bus';
        default:
          return 'icon-location-2';
      }
    },

    updateDefaultZones() {
      if (this.defaultZones) {
        let zoneSelected = null;
        if (this.defaultZones.zone_from === -1) {
          // cabify
          zoneSelected = {
            id: -1,
            label: `${this.defaultZones.zone_from_name} (${this.defaultZones.zone_from_address})`,
            type: 'Zone',
          };
        } else {
          //  civitatis
          zoneSelected = this.zones.find((data) => data.id === this.defaultZones.zone_from);
          // make a copy of the zone original data, not linked between them.
          zoneSelected = JSON.parse(JSON.stringify(zoneSelected));
          zoneSelected.label = `${this.defaultZones.zone_from_name} (${this.defaultZones.zone_from_address})`;
        }

        // add the store direction to zones list
        this.originsList.unshift(zoneSelected);
        this.origin = zoneSelected;
        this.updateDestination(this.origin, 'updateDefaultZones');
        this.destination = this.zones.find((data) => data.id === this.defaultZones.zone_to);

        if (document.getElementById('origin_dropdown').classList.contains('show')) {
          document.getElementById('origin_btn').click();
        }
      }
    },

    updateDestination(from, caller = '') {
      this.showCars = false;
      this.destination = null;
      let list = [];

      const originData = this.zones.find((data) => data.id === from.id);
      if (originData.related) {
        list = originData.related;
      } else {
        list = this.zones;
      }
      list = list.filter((item) => item.id !== from.id);
      list.sort((a, b) => a.label.localeCompare(b.label));

      this.origin = from;
      this.destinationsList = list;

      if (caller !== 'updateDefaultZones') {
        setTimeout(() => { document.getElementById('destination_btn').click(); }, 500);
      }
    },

    zonesSelected(to) {
      this.destination = to;
      if (this.origin && this.destination) {
        this.$emit('zonesSelected', this.origin.id, this.destination.id);
      }
    },

    reverse() {
      const { origin, destination } = this;
      this.origin = destination;
      this.destination = origin;
      this.zonesSelected(this.destination);
    },

    openDatetimeSelector() {
      document.getElementById('datetime').focus();
    },

    closeDatePicker() {
      if (this.selectedDate) {
        const { lang } = this.$store.state.main;
        this.dateToShow = formatDateToDisplay(this.selectedDate, lang);

        this.$emit('zonesSelected', this.origin.id, this.destination.id, this.selectedDate);
      }
    },
    clickNow() {
      if (this.selectedDate) {
        this.selectedDate = null;
        this.dateToShow = this.$t('lang.transfer.now');

        this.$emit('zonesSelected', this.origin.id, this.destination.id, this.selectedDate);
      }
    },
  },
};
</script>

<style scoped>

.icon-inputs i {
  font-size: unset;
  position: unset;
  line-height: unset;
  top: 1px;
  right: 1px;
  display: unset;
  width: 30px;
  -webkit-box-sizing: content-box;
  box-sizing: unset;
  height: unset;
  z-index: 4;
  color: #999;
  padding: 0 5px 0 0;
  margin-right: 5px;
  border: none;
  border-right: 1px solid rgba(153, 153, 153, .47);
  text-align: center;
  background-color: transparent;
}

.select-button{
  width: 100%;
  background-color: #fff;
  text-align: left;
  font-size: .875rem;
  border-radius: 3px;
  border: 1px solid #d2d8dd;
  padding: 0.375rem 0.75rem;
  height: 50px;
  display: flex;
  align-items: center;
  padding-right: 20px; /* Espacio para la flecha */
  justify-content: space-between;
}
.select-button span{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px; /* Espacio adicional para evitar que el texto toque la flecha */
}

.select-button:after{
  float: right;
  margin-top: 8px;
}

.dropdown-menu{
  width: 100%;
  max-height: 50vh;
  overflow-y: scroll;
}

.btn-reverse{
  background-color: #ffffff; /* Fondo blanco */
  border: 1px solid #ddd;    /* Borde gris claro */
  border-radius: 4px;        /* Bordes redondeados suaves */
  width: 30px;
  height: 30px;
  padding: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Sombra sutil */
  cursor: pointer;
  transition: all 0.3s ease; /* Transición suave */
  text-align: center;        /* Centrar el contenido */
  line-height: 1;            /* Ajustar la altura del ícono */
  margin-bottom: .5rem;
}

.btn-reverse:hover {
  background-color: #f8f9fa; /* Color al pasar el cursor */
  border-color: #ccc;        /* Cambio de borde */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Sombra más notable */
}

.btn-reverse-mobile {
  background-color: #ffffff;
  transform: rotate(90deg);
  width: 30px;
  height: 30px;
  padding: 0;
  margin: -.3rem 0 -1rem 0;
  z-index: 1;
  position: relative;
  float: right;
}
</style>
